// @flow

import React from 'react';
import { connect } from 'react-redux';
import FilterHeading from '../filterHeading';
import Divider from '../../divider';
import RangeSliderFacet from './rangeSliderFacet';
import CheckboxesFacet from './checkboxFacet';
import { facetMap, TYPE_TERM, TYPE_RANGE } from '../../../store/assortment/config';
import { getFacetTranslation } from '../../../store/assortmentSettings';

type FacetProp = { [string]: number };

type OwnProps = {|
  name: string,
  buckets: FacetProp,
|};

type StateProps = {|
  getfacetTranslation: (name: string) => number,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const map = {
  [TYPE_RANGE]: RangeSliderFacet,
  [TYPE_TERM]: CheckboxesFacet,
};

const Facet = ({
  name,
  getfacetTranslation,
  buckets,
}: Props) => {
  const FacetComponent = map[facetMap[name]];
  return (
    <>
      <FilterHeading>{getfacetTranslation(name)}</FilterHeading>
      <FacetComponent buckets={buckets} name={name} />
      <Divider />
    </>
  );
};

const mapStateToProps = (state): StateProps => ({
  getfacetTranslation: facetName => getFacetTranslation(state, facetName),
});

export default connect<any, OwnProps, StateProps, any, any, any>(
  mapStateToProps,
)(Facet);
